import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "text-primary" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { key: 7 }
const _hoisted_13 = { key: 8 }
const _hoisted_14 = { key: 9 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (e) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "mb-8",
        key: e.key
      }, [
        (e.format.answerType === 'sectionLabel')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h2", null, _toDisplayString(e.format.label), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h4", _hoisted_4, _toDisplayString(e.format.label) + " " + _toDisplayString(e.format.isRequired ? "*" : ""), 1),
              (e.format.answerType === 'shortText')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_v_text_field, {
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      "model-value": e.value,
                      "onUpdate:modelValue": ($event: any) => (_ctx.inputValue($event, e))
                    }, null, 8, ["model-value", "onUpdate:modelValue"])
                  ]))
                : (e.format.answerType === 'mediumText')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_v_textarea, {
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "",
                        "model-value": e.value,
                        "onUpdate:modelValue": ($event: any) => (_ctx.inputValue($event, e))
                      }, null, 8, ["model-value", "onUpdate:modelValue"])
                    ]))
                  : (e.format.answerType === 'longText')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_v_textarea, {
                          variant: "outlined",
                          density: "compact",
                          "hide-details": "",
                          "model-value": e.value,
                          "onUpdate:modelValue": ($event: any) => (_ctx.inputValue($event, e))
                        }, null, 8, ["model-value", "onUpdate:modelValue"])
                      ]))
                    : (e.format.answerType === 'number')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_v_text_field, {
                            variant: "outlined",
                            density: "compact",
                            "hide-details": "",
                            type: "number",
                            "model-value": e.value,
                            "onUpdate:modelValue": ($event: any) => (_ctx.inputValue($event, e))
                          }, null, 8, ["model-value", "onUpdate:modelValue"])
                        ]))
                      : (e.format.answerType === 'date')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_v_text_field, {
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              type: "date",
                              "model-value": e.value,
                              "onUpdate:modelValue": ($event: any) => (_ctx.inputValue($event, e))
                            }, null, 8, ["model-value", "onUpdate:modelValue"])
                          ]))
                        : (e.format.answerType === 'singleSelect')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(_component_v_select, {
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "",
                                "model-value": e.value,
                                items: e.format.options,
                                "item-title": "label",
                                "item-value": "value",
                                "onUpdate:modelValue": ($event: any) => (_ctx.inputValue($event, e))
                              }, null, 8, ["model-value", "items", "onUpdate:modelValue"])
                            ]))
                          : (e.format.answerType === 'multiSelect')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_v_select, {
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  multiple: "",
                                  "model-value": e.value,
                                  items: e.format.options,
                                  "item-title": "label",
                                  "item-value": "value",
                                  "onUpdate:modelValue": ($event: any) => (_ctx.inputValue($event, e))
                                }, null, 8, ["model-value", "items", "onUpdate:modelValue"])
                              ]))
                            : (e.format.answerType === 'boolean')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createVNode(_component_v_checkbox, {
                                    "model-value": e.value,
                                    label: e.format.label,
                                    "onUpdate:modelValue": ($event: any) => (_ctx.inputValue($event, e)),
                                    "hide-details": "",
                                    density: "compact"
                                  }, null, 8, ["model-value", "label", "onUpdate:modelValue"])
                                ]))
                              : (e.format.answerType === 'month')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode(_component_v_text_field, {
                                      variant: "outlined",
                                      density: "compact",
                                      "model-value": e.value,
                                      type: "month",
                                      "onUpdate:modelValue": ($event: any) => (_ctx.inputValue($event, e))
                                    }, null, 8, ["model-value", "onUpdate:modelValue"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("div", null, _toDisplayString(e.format.answerType), 1),
                                    _createElementVNode("div", null, _toDisplayString(e), 1)
                                  ]))
            ]))
      ]))
    }), 128))
  ]))
}